export const STANDARD_MUSIC_MODEL = 'lyria-3-pro-preview' as const;
export const PREMIUM_MUSIC_MODEL = 'lyria-3.5' as const;

export const MUSIC_GENERATION_MODELS = [STANDARD_MUSIC_MODEL, PREMIUM_MUSIC_MODEL] as const;

export type MusicGenerationModel = (typeof MUSIC_GENERATION_MODELS)[number];

export const MUSIC_MODEL_OPTIONS = [
  { value: STANDARD_MUSIC_MODEL, label: 'Lyx0.1', requiresOto2: false },
  { value: PREMIUM_MUSIC_MODEL, label: 'Lyx3pro', requiresOto2: true },
] as const;

export function isMusicGenerationModel(value: unknown): value is MusicGenerationModel {
  return (
    typeof value === 'string' && MUSIC_GENERATION_MODELS.includes(value as MusicGenerationModel)
  );
}

export function musicModelLabel(model: MusicGenerationModel): string {
  return MUSIC_MODEL_OPTIONS.find((option) => option.value === model)?.label ?? 'Lyx0.1';
}
